export default __webpack_public_path__ + "static/media/dokki.511cb211.jpg";